module.exports = __webpack_public_path__ + "img/logo-plataforma_web_light_128.9a723c3d.png";